import BaseTooltip from 'base-components/BaseTooltip/BaseTooltip';
import { JSXElementConstructor, ReactElement, useRef } from 'react';
import 'scss/Main.scss';

const BaseDataGridTooltipedFormatter = ({
    children,
    showAlways,
    overflownElementClassName,
    tooltipText,
    ...props
}: React.HTMLAttributes<HTMLDivElement> & {
    tooltipText?: string | ReactElement<any, string | JSXElementConstructor<any>>;
    showAlways?: boolean;
    overflownElementClassName?: string;
}) => {
    const textRef = useRef(null);

    return (
        <>
            <div ref={textRef} className="text-ellipsis" {...props}>
                {children}
            </div>

            <BaseTooltip
                target={textRef}
                showOnlyIfOverflownRef={showAlways ? undefined : textRef}
                overflownElementClassName={overflownElementClassName}
                placement="bottom"
                delay={{ show: 0, hide: 0 }}
                hideArrow
            >
                {tooltipText ?? children}
            </BaseTooltip>
        </>
    );
};

export default BaseDataGridTooltipedFormatter;
